module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-8-133110463b128e3c49e7b0489849e362.jpg";